<div class="page-container">
    <div class="intro">
        <span class="caption">
            Welcome to Kenneth Geoffrey’s, the top barbershop in Collingwood’s thriving grooming scene. Our shop is not the run-of-the-mill barbershop – We’re all about fun, quality, and class.<br><br>
        </span>
    </div>
    <app-book-now></app-book-now>
    <app-about-us></app-about-us>
</div>
